import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=34f4dc31&"
var script = {}
import style0 from "./detail.vue?vue&type=style&index=0&id=34f4dc31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports